<template>
  <div class="product-box-wide__segment-image">
    <div
      class="product-box-wide__product-flags"
      v-if="productBoxData.flags"
    >
      <flags
        :flags="productBoxData.flags"
        :limit="3"
        :award-limit="1"
        :white-list="settings.flags.whitelistImage"
      />
    </div>
    <component
      :is="productBoxData.linked ? 'a' : 'div'"
      :href="productBoxData.linked ? productBoxData.url : null"
      :target="productBoxData.linked ? linkTarget : null"
      class="product-box-wide__image-wrapper"
      :class="{ 'product-box-wide__image-wrapper--bottle': isBoxTypeVertical }"
    >
      <div
        class="lazy-load-image product-box-wide__image"
      >
        <image-element
          img-class="lazy-load-image__image"
          :src="imgSrc"
          :title="productBoxData.images[1].title"
          :alt="productBoxData.images[1].alt"
          :webp="true"
        />
      </div>
    </component>
  </div>
</template>
<script setup lang="ts">
  import {inject} from 'vue';
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import Flags from '../../../bps/components/flags/flags.vue';
  import ImageElement from '../../../bps/components/imageElement/imageElement.vue';
  import {ProductBoxWideSettings} from './productBoxWideSettings';

  defineProps<{
    productBoxData: ProductBoxData;
    settings: ProductBoxWideSettings;
    imgSrc: string[];
    isBoxTypeVertical: boolean;
    isBottle: boolean;
  }>();

  const linkTarget = inject('productBoxLinkTarget', null);
</script>
